import { JobPhaseReceivableCreatableInterface } from '../interfaces/job-phase-receivable-creatable.interface';
import { JobPhaseReceivableDto } from './job-phase-receivable.dto';
import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';

export class JobPhaseReceivableCreateDto
  extends IntersectionType(
    PickType(JobPhaseReceivableDto, ['jobPhaseId', 'supplyProIntegrated', 'billed'] as const),
    PartialType(
      PickType(JobPhaseReceivableDto, ['invoicePOAmount', 'internalInvoiceNumber'] as const),
    ),
  )
  implements JobPhaseReceivableCreatableInterface {}
